<template>
  <a-select v-model:value="brands" style="width:230px" @change="changeSelect">
   <a-select-option  :value="0" >默认品牌</a-select-option>
    <a-select-option :value="v.id" v-for=" v in brandList" :key="v.brand_id">{{v.sub_brand_name}}</a-select-option>
  </a-select>
</template>

<script>
import { subBrand } from "@/api/brand";
import { ref } from "@vue/reactivity";
import { onMounted } from "@vue/runtime-core";
export default {
  name: "selectBrand",
  props: { sub_brand_id: String || Number },
  setup(props, { emit }) {
    const brands = ref(0);
    const changeSelect = (e) => {
      emit("update:value", e);
    };
    const brandList = ref([]);
    const initData = async () => {
      let result = await subBrand({limit:10000})
        .then((res) => res.data)
        .catch((error) => error);
      brandList.value = result.data.data;
      console.log(brandList.value);
    };
    onMounted(() => {
      initData();
      if (props.sub_brand_id) {
        brands.value = props.sub_brand_id;
      }
       emit("update:value", brands.value);
    });
    return {
      brands,
      changeSelect,
      brandList,
    };
  },
};
</script>